/** Maximum route pathname length accepted from clients — well above any real DMS URL path. */
export const ASSISTANT_LOCATION_PATH_MAX_CHARACTERS = 2_048;
